// src/features/system/tenants/api/tenantsApi.ts
import { bff } from '@/lib/http/bff';

export interface Tenant {
  id_tenant: number;
  tenant_name: string;
  code: string;
  display_name?: string | null;
  description?: string | null;
  active?: boolean | null;
  created_at?: string | null;
}

export interface TenantCreateIn  { tenant_name: string }
export interface TenantCreateOut { id_tenant: number }

const BASE = '/tenants'; // BFF base (bff client already prefixes /bff)

export const fetchTenants = (): Promise<Tenant[]> =>
  bff.get<Tenant[]>(`${BASE}`);

export const createTenant = (payload: TenantCreateIn): Promise<TenantCreateOut> =>
  bff.post<TenantCreateOut, TenantCreateIn>(`${BASE}/create`, payload);

export const deleteTenant = (idTenant: number): Promise<{ deleted: boolean; tenant_id: number }> =>
  bff.del(`${BASE}/${idTenant}`);

// ── P10: EAV attributes ────────────────────────────────────────────────
// Free-form attribute bag persisted via HotStream events, latest-wins
// projection returned by the BFF. Typed as `unknown` because new
// attributes arrive without DDL — the FE maps known keys into typed
// columns at render time.

export type TenantAttributes = Record<string, unknown>;

export interface TenantAttributesResponse {
  tenant_id: number;
  attributes: TenantAttributes;
}

export interface TenantAttributesWriteResult {
  tenant_id: number;
  written:   number;
  failed:    number;
  skipped:   number;
}

export const fetchTenantAttributes = (idTenant: number): Promise<TenantAttributesResponse> =>
  bff.get<TenantAttributesResponse>(`${BASE}/${idTenant}/attributes`);

export const writeTenantAttributes = (
  idTenant: number,
  attributes: TenantAttributes,
  source: 'manual' | 'llm_extractor' | 'system' = 'manual',
): Promise<TenantAttributesWriteResult> =>
  bff.patch<TenantAttributesWriteResult, { attributes: TenantAttributes; source: string }>(
    `${BASE}/${idTenant}/attributes`,
    { attributes, source },
  );
